import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../../stores/user-store';
import CallIcon from '@mui/icons-material/Call';
import ShuffleIcon from '@mui/icons-material/Shuffle';
import Summarize from '@mui/icons-material/Summarize';
import SettingsPhone from '@mui/icons-material/SettingsPhone';
import Grading from '@mui/icons-material/Grading';
import Logo from '../../assets/images/atria-logo.avif'
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import PersonIcon from '@mui/icons-material/Person';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import StoreIcon from '@mui/icons-material/Store';
import SchoolIcon from '@mui/icons-material/School';
import BusinessIcon from '@mui/icons-material/Business';
import DescriptionIcon from '@mui/icons-material/Description';
import ContactMailIcon from '@mui/icons-material/ContactMail';

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);



export default function MiniDrawer() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menu, setMenu] = React.useState('');
  const [subMenu, setSubMenu] = React.useState(false);
  const [subMenuText, setSubMenuText] = React.useState('');
  const userData = useUserStore;
  const navigate = useNavigate();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {

    // alert('pppp')

    let url = window.location.href;

    let activeMenu = 'leads';

    if (url.includes('booking')) {
      activeMenu = 'bookings';
    }
    else if (url.includes('user')) {
      activeMenu = 'users';
    }
    else if (url.includes('profile')) {
      activeMenu = 'profiles';
    }

    else if (url.includes('dashboard')) {
      activeMenu = 'dashboards';
    }


    else if (url.includes('project')) {
      activeMenu = 'projects';
    }
    else if (url.includes('assigned')) {
      activeMenu = 'assigned';
    }
    else if (url.includes('institute')) {
      activeMenu = 'institutes';
    }
    else if (url.includes('student')) {
      activeMenu = 'students';
    }
    else if (url.includes('agreement')) {
      activeMenu = 'agreements';
    }
    else if (url.includes('enquiries')) {
      activeMenu = 'enquiries';
    }


    // alert(activeMenu);


    setMenu(activeMenu);

  }, []);

  const navigateTo = (route, type) => {
    navigate('/' + route, { replace: true });
    setMenu(route);
  }

  const LogOut = () => {
    userData.setState({ userId: '', name: '', username: '', email: '', mobile: '', profile: '', orgId: '', orgName: '', token: '', isLogin: false });
    navigate('/login');
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar className='calleyo-bar' position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Uprn Crm
          </Typography>
          <div className='header-icon'>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem>{userData.getState().username}</MenuItem>
              <MenuItem onClick={LogOut}>Log Out</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          {/* <Box style={{ width: '80%', textAlign: 'center' }}>
            <img style={{ height: '50px', width: 'fit-content' }} src={Logo} />
          </Box> */}
          <Box>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </Box>

        </DrawerHeader>
        <Divider />
        <List>
          {/* <ListItem title='Dashboard' key={'Dashboard'} disablePadding sx={{ display: 'block' }} onClick={() => navigateTo('summary', 'menu')}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                  color: menu == 'summary' ? '#042740' : ''
                }}
              >
                {<DashboardIcon />}
              </ListItemIcon>
              <ListItemText primary={'Dashboard'} sx={{ opacity: open ? 1 : 0 }} />

            </ListItemButton>


          </ListItem> */}

          {
            userData.getState().allowedRoutes.includes('Dashboard') ?
              <ListItem title='Dashboard' key={'Dashboard'} disablePadding sx={{ display: 'block' }} onClick={() => navigateTo('dashboards', 'menu')}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      color: menu == 'dashboards' ? '#042740' : ''
                    }}
                  >
                    {<DashboardIcon />}
                  </ListItemIcon>
                  <ListItemText primary={'Dashboard'} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>
              :
              null
          }

          {
            userData.getState().allowedRoutes.includes('Leads') ?
              <ListItem title='Leads' key={'Leads'} disablePadding sx={{ display: 'block' }} onClick={() => navigateTo('leads', 'menu')}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      color: menu == 'leads' ? '#042740' : ''
                    }}
                  >
                    {<LeaderboardIcon />}
                  </ListItemIcon>
                  <ListItemText primary={'Leads'} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>
              :
              null
          }



          {
            userData.getState().allowedRoutes.includes('Enquiry') ?
              <ListItem title='Enquiry' key={'Enquiry'} disablePadding sx={{ display: 'block' }} onClick={() => navigateTo('enquiries', 'menu')}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      color: menu == 'enquiries' ? '#042740' : ''
                    }}
                  >
                    {<ContactMailIcon />}
                  </ListItemIcon>
                  <ListItemText primary={'Enquiry'} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>
              :
              null
          }
          {
            userData.getState().allowedRoutes.includes('Institutes') ?
              <ListItem title='Institutes' key={'Institutes'} disablePadding sx={{ display: 'block' }} onClick={() => navigateTo('institutes', 'menu')}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      color: menu == 'institutes' ? '#042740' : ''
                    }}
                  >
                    {<BusinessIcon />}
                  </ListItemIcon>
                  <ListItemText primary={'Institutes'} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>
              :
              null
          }
          {
            userData.getState().allowedRoutes.includes('Students') ?
              <ListItem title='Students' key={'Students'} disablePadding sx={{ display: 'block' }} onClick={() => navigateTo('students', 'menu')}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      color: menu == 'students' ? '#042740' : ''
                    }}
                  >
                    {<SchoolIcon />}
                  </ListItemIcon>
                  <ListItemText primary={'Students'} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>
              :
              null
          }
         {
    userData.getState().allowedRoutes.includes('Agreements') ?
        <ListItem
            title="Agreements"
            key="Agreements"
            disablePadding
            sx={{ display: 'block' }}
            onClick={() => navigateTo('agreements', 'menu')}
        >
            <ListItemButton
                sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                }}
            >
                <ListItemIcon
                    sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'center',
                        color: menu === 'agreements' ? '#042740' : ''
                    }}
                >
                    <DescriptionIcon />
                </ListItemIcon>

                <ListItemText
                    primary="Agreements"
                    sx={{ opacity: open ? 1 : 0 }}
                />
            </ListItemButton>
        </ListItem>
        :
        null
}


          {/* {
            userData.getState().allowedRoutes.includes('Assigned') ?

              <ListItem title='Assigned Leads' key={'Assigned Leads'} disablePadding sx={{ display: 'block' }} onClick={() => navigateTo('assigned-leads', 'menu')}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      color: menu == 'assigned' ? '#042740' : ''
                    }}
                  >
                    {<ShoppingBasketIcon />}
                  </ListItemIcon>
                  <ListItemText primary={'Assigned Leads'} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>

              :

              null
          } */}


          {
            userData.getState().allowedRoutes.includes('Users') ?

              <ListItem title='Users' key={'Users'} disablePadding sx={{ display: 'block' }} onClick={() => navigateTo('users', 'menu')}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      color: menu == 'users' ? '#042740' : ''
                    }}
                  >
                    {<GroupAddIcon />}
                  </ListItemIcon>
                  <ListItemText primary={'Users'} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>

              :


              null
          }



          {
            userData.getState().allowedRoutes.includes('Profiles') ?

              <ListItem title='Profiles' key={'Profiles'} disablePadding sx={{ display: 'block' }} onClick={() => navigateTo('profiles', 'menu')}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      color: menu == 'profiles' ? '#042740' : ''
                    }}
                  >
                    {<PersonIcon />}
                  </ListItemIcon>
                  <ListItemText primary={'Profiles'} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>

              :

              null

          }



          {
            userData.getState().allowedRoutes.includes('Tickets') ?
              <ListItem title='Tickets' key={'Tickets'} disablePadding sx={{ display: 'block' }} onClick={() => navigateTo('tickets', 'menu')}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      color: window.location.href.includes('ticket') || menu == 'tickets' ? '#042740' : ''
                    }}
                  >
                    {<ConfirmationNumberIcon />}
                  </ListItemIcon>
                  <ListItemText primary={'Tickets'} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>
              :
              null
          }


          {
            userData.getState().allowedRoutes.includes('Projects') ?

              <ListItem title='Projects' key={'Projects'} disablePadding sx={{ display: 'block' }} onClick={() => navigateTo('projects', 'menu')}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                      color: window.location.href.includes('project') || menu == 'projects' ? '#042740' : ''
                    }}
                  >
                    {<StoreIcon />}
                  </ListItemIcon>
                  <ListItemText primary={'Projects'} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>

              :


              null
          }



        </List>
        <Divider />

      </Drawer>
      <Box component="main" sx={{ flexGrow: 1 }}>
        <DrawerHeader />
      </Box>
    </Box>
  );
}